import styled from 'styled-components'

type StyledProps = {
  isSelected?: boolean;
  isPopular?: boolean;
  isTrial?: boolean;
}

const StyledSubscriptionOption = styled.div<StyledProps>`
  padding: 1rem;
  border-radius: 10px;
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  font-family: ${({ theme }) => theme.fonts.lexend};
  box-shadow: ${({ isPopular }) =>
    (isPopular ? 'inset 0 0 0 1px #3eae9a40' : 'inset 0 0 0 0 transparent')};
  transition: background-color 0.2s, box-shadow 0.4s;

  margin: ${({ isTrial }) => (isTrial ? '8px 16px' : '0px')};

  ${({ isSelected, theme }) =>
    isSelected &&
    `
    background-color: ${theme.colors.background};
    box-shadow: inset 0 0 0 2px ${theme.colors.green[300]};
  `}

  input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    -webkit-appearance: none;
    cursor: pointer;
    z-index: 1;

    &:checked ~ .fake-radio {
      background: ${({ theme }) => theme.colors.green[300]};
    }
  }

  .fake-radio {
    width: 25px;
    height: 25px;
    background: ${({ theme }) => theme.colors.background};
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.colors.green[300]};
    flex-shrink: 0;
    margin-right: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.background};
    position: relative;

    &.check-anim::after {
      content: '';
      position: absolute;
      max-width: 7px;
      height: 8px;
      background: ${({ theme }) => theme.colors.green[300]};
      right: 14px;
      bottom: 5px;
      animation: check-in-after 0.2s forwards ease-in;
      width: 100%;
      border-radius: 23px;
    }

    &.check-anim::before {
      content: '';
      position: absolute;
      max-width: 12px;
      height: 12px;
      background: ${({ theme }) => theme.colors.green[300]};
      right: 2px;
      bottom: 5px;
      animation: check-in-before 0.4s forwards ease-out;
      animation-delay: 0.2s;
      width: 100%;
      border-radius: 3px;
    }

    @keyframes check-in-after {
      from {
        max-width: 7px;
      }
      to {
        max-width: 0;
      }
    }

    @keyframes check-in-before {
      from {
        max-width: 12px;
      }
      to {
        max-width: 0;
      }
    }

    svg {
      height: 17px;

      path {
        stroke-width: 3px;
      }
    }
  }

  .subscription-details {
    display: grid;
    grid-gap: 5px;

    .subscription-title {
      color: ${({ theme }) => theme.colors.gray[700]};
      font-size: 19px;
      font-weight: 300;

      .subscription-discount {
        margin-left: 8px;
        text-decoration: line-through;
        color: ${({ theme }) => theme.colors.green[500]};
      }
    }

    .subscription-sub-title {
      color: ${({ isPopular, theme }) =>
    (isPopular ? theme.colors.green[300] : theme.colors.gray[500])};
      font-size: 13px;
      font-family: ${({ theme }) => theme.fonts.nunito};
      font-weight: 600;
    }
  }

  s {
    position: absolute;
    right: 1rem;
    height: 30px;
    padding: 0 12px;
    border-radius: 50rem;
    background-color: ${({ theme }) => theme.colors.red[100]};
    color: ${({ theme }) => theme.colors.red[600]};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    font-weight: 300;
  }

  .subscription-popular {
    position: absolute;
    right: -21px;
    top: -25px;
  }

  &:hover {
    background-color: ${({ isSelected, theme }) =>
    (isSelected ? theme.colors.background : '#00000006')};
    box-shadow: inset 0 0 0
      ${({ isSelected, theme }) =>
    (isSelected ? `2px ${theme.colors.green[300]}` : '1.2px #00000006')};
  }
`

export default StyledSubscriptionOption
